module.exports = _.partialRight;